export default function guest({ next, store }) {
  if (!store.getters.userLoggedIn) {
    return next();
  } else {
    return next({
      path: "/",
    });
  }
}
